<div class="main-container">
  <div class="container">
    <h3 class="title"></h3>
    <app-settings-card-payments-section
      [sectionTitle]="'advanced-pages.business-entity.title' | i18next"
      [description]="'advanced-pages.business-entity.description' | i18next"
    >
    </app-settings-card-payments-section>

    @if (!isLoading) {
    <radio-button-group
      [selectedBusinessType]="selectedBusinessType"
      [businessTypes]="businessTypes"
    />
    }
  </div>

  <!-- <app-settings-card-payments-section
  [sectionTitle]="'advanced-pages.business-entity.title' | i18next"
  [description]="'advanced-pages.business-entity.description' | i18next"
>


  <div class="tw-h-20"></div>
  <div
    class="tw-fixed tw-bottom-0 tw-left-0 tw-flex tw-px-5 tw-py-4 tw-gap-4 tw-w-full"
  >
    
    <button class="btn-secondary tw-w-1/2" (click)="navigateBack()">
      {{ "advanced-pages.business-entity.back" | i18next }}
    </button>
    <button
      class="btn-primary tw-w-1/2"
      (click)="navigateToBusinessDocuments()"
    >
      {{ "advanced-pages.business-entity.next" | i18next }}
    </button>
  </div>
</app-settings-card-payments-section> -->
</div>

<app-cta-buttons
  currentPage="entity"
  [backButton]="false"
  [pageNames]="advancedPages"
  tier="advanced"
  [disabled]="!this.selectedBusinessType.value"
  (nextEvent)="onNextPressed()"
  [nextCallback]="onNextPressed"
  [isLoading]="isLoading"
/>
